import {
  OFFLINE_CACHE_POLICIES,
  type OfflineCachePolicy,
} from "./cachePolicyConfig"

export { OFFLINE_CACHE_POLICIES }
export type {
  OfflineCachePolicy,
  OfflineCacheStrategy,
} from "./cachePolicyConfig"

function requestMethod(input: RequestInfo | URL, init?: RequestInit) {
  if (init?.method) return init.method.toUpperCase()
  if (input instanceof Request) return input.method.toUpperCase()
  return "GET"
}

export function getOfflineCachePolicy(
  input: RequestInfo | URL,
  init?: RequestInit,
): OfflineCachePolicy | null {
  if (requestMethod(input, init) !== "GET") return null

  const url = new URL(
    input instanceof Request ? input.url : input.toString(),
    window.location.href,
  )

  if (url.hostname === "api.ala.org.au") return OFFLINE_CACHE_POLICIES.alaApi

  if (
    url.hostname.endsWith("nasti.pages.dev") &&
    url.pathname.startsWith("/api/ala_image_proxy")
  )
    return OFFLINE_CACHE_POLICIES.alaRemoteImages

  if (url.hostname.endsWith("mapbox.com"))
    return OFFLINE_CACHE_POLICIES.mapboxTiles

  return null
}
